export default {
  name: "Branding",
  path: "/profile/documents/branding",
  title: "Branding",
  component: () => import("@/views/Profile/Components/Branding")
};
